/**
 * Слой гидроизоляции комнат.
 */
import { create } from "zustand";
import { WaterproofMaterial } from "@/shared/catalog";
import type { RoomWaterproof } from "@/shared/plan";

interface WaterproofLayerState {
	items: Record<string, RoomWaterproof>;
	visible: boolean;

	setRoomWaterproofMaterial: (roomId: string, material: WaterproofMaterial) => void;
	removeRoomWaterproof: (roomId: string) => void;

	setVisible: (visible: boolean) => void;
	toggleVisible: () => void;

	restoreWaterproofs: (roomWaterproofs: Record<string, RoomWaterproof>) => void;
}

export const useWaterproofStore = create<WaterproofLayerState>((set) => ({
	items: {},
	visible: false,

	setRoomWaterproofMaterial: (roomId: string, material: WaterproofMaterial) =>
		set((s) => {
			const roomWaterproofs = {
				...s.items,
				[roomId]: {
					id: roomId,
					roomId,
					material,
				},
			};
			return { items: roomWaterproofs };
		}),

	removeRoomWaterproof: (roomId) =>
		set((s) => {
			if (!s.items[roomId]) return s;
			const roomWaterproofs = { ...s.items };
			delete roomWaterproofs[roomId];
			return { items: roomWaterproofs };
		}),

	setVisible: (visible) => set({ visible }),
	toggleVisible: () => set((s) => ({ visible: !s.visible })),

	restoreWaterproofs: (roomWaterproofs) => set({ items: roomWaterproofs }),
}));
